import axios from "axios";
// TODO: stop method should also abort the pending tasks

export default function withPolling(task, duration = 10000) {
  let running = false;
  let currentTask = null;

  async function runTask() {
    if (!running) {
      return;
    }

    try {
      await task();
      running = false;
    } catch (e) {
      if (axios.isCancel(e)) {
        running = false;
        clearTimeout(currentTask);
        return;
      }
      currentTask = setTimeout(runTask, duration);
    }
  }

  return {
    start() {
      if (running) {
        return;
      }
      running = true;
      runTask();
    },
    stop() {
      running = false;
      clearTimeout(currentTask);
    },
  };
}
